import type { EventSearchSummary } from '@src/models/interfaces/event.interface';
import {
  formatEventDateTime,
  getDivisionName,
} from '@src/packages/events/components/TimelineEvent/utils/mapTimelineEventPresentation';

export interface EventSearchResultLabels {
  title: string;
  details: string[];
}

/** Row labels for an event hit, reusing the Timeline card presentation. */
export const getEventSearchResultLabels = (
  event: EventSearchSummary,
): EventSearchResultLabels => {
  const actorName = event.user?.name?.trim() || event.user?.email?.trim() || '';
  const eventTypeName = event.eventType?.name?.trim() ?? '';
  const divisionName = getDivisionName({
    id: event.id,
    createdAtDevice: event.createdAtMs ?? 0,
    division: event.division,
  });

  return {
    title: [actorName, eventTypeName].filter(Boolean).join(' · ') || event.id,
    details: [
      event.createdAtMs != null ? formatEventDateTime(event.createdAtMs) : '',
      divisionName,
    ].filter(Boolean),
  };
};
